var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "map-filter component" },
    [
      _vm.showFilter
        ? _c("accessible-tabs", [
            _c(
              "ul",
              {
                staticClass: "filter-items container",
                attrs: { role: "tablist" },
              },
              [
                _c(
                  "li",
                  {
                    staticClass: "filter-item tab-group-button",
                    class: [{ active: !_vm.currentRegion }],
                    attrs: { role: "presentation" },
                    on: {
                      click: function ($event) {
                        return _vm.handleRegionClick()
                      },
                      keypress: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.handleRegionClick()
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar",
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.handleRegionClick()
                        },
                      ],
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tc("booking.allRegions")) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.regions, function (region, i) {
                  return _c(
                    "li",
                    {
                      key: region.Id,
                      staticClass: "filter-item",
                      class: [{ active: _vm.currentRegion === region.Id }],
                      attrs: { role: "presentation" },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "tab-group-button",
                          attrs: {
                            id: "region-filter-" + i,
                            href: "",
                            role: "tab",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.handleRegionClick(region.Id)
                            },
                            keypress: [
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.handleRegionClick(region.Id)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.handleRegionClick(region.Id)
                              },
                            ],
                          },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(region.Title) + "\n        "
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm._l(_vm.externalMaps, function (externalMap, i) {
                  return _c(
                    "li",
                    {
                      key: externalMap.Title + i,
                      staticClass: "filter-item",
                      attrs: { role: "presentation" },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "tab-group-button",
                          attrs: {
                            id: "region-filter-" + i,
                            href: externalMap.Link,
                            target: "_self",
                            role: "tab",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(externalMap.Title) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "map-filter-wrapper" },
        [
          _vm.showFilter
            ? _c("transition", { attrs: { name: "slide-left" } }, [
                _vm.showRegionList
                  ? _c(
                      "div",
                      { staticClass: "map-filter-list-wrapper container" },
                      _vm._l(_vm.filteredItemsByRegion, function (region, key) {
                        return _c("div", { key: key, staticClass: "region" }, [
                          _c("span", { staticClass: "region-heading" }, [
                            _vm._v(_vm._s(key)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "cities" },
                            _vm._l(region, function (property, index) {
                              return _c(
                                "li",
                                {
                                  key: index,
                                  attrs: { "data-name": property.Title },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      class: [
                                        property.Id === _vm.currentPropertyId
                                          ? "active"
                                          : "",
                                      ],
                                      attrs: { tabindex: "0" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.handlePropertyClick(
                                            property.Id
                                          )
                                        },
                                        keypress: [
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.handlePropertyClick(
                                              property.Id
                                            )
                                          },
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "space",
                                                32,
                                                $event.key,
                                                [" ", "Spacebar"]
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.handlePropertyClick(
                                              property.Id
                                            )
                                          },
                                        ],
                                      },
                                    },
                                    [_vm._v(_vm._s(property.Title))]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "map google-map component",
              attrs: { id: "google-map" },
            },
            [
              _c("google-map", {
                ref: "mapRef",
                attrs: { properties: _vm.filteredItems, options: _vm.options },
                on: { loaded: _vm.handleMapLoaded },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }